import {RelativeLink} from 'lib/ui/link/RelativeLink'
import styled from 'styled-components'
import {useEventRoutes} from 'organization/Event/EventRoutes'
import React from 'react'
import grey from '@material-ui/core/colors/grey'
import {areaRoutes} from 'organization/Event/Area/AreaRoutes'
import {useArea} from 'organization/Event/Area/AreaProvider'
import {DragHandle} from 'lib/ui/drag-and-drop'
import {DraggableProvidedDragHandleProps} from 'react-beautiful-dnd'

export default function Card(props: {
  dragHandleProps?: DraggableProvidedDragHandleProps | null
}) {
  const {area, totalAttendees} = useArea()
  const label = `view ${area.name} area`
  const eventRoutes = useEventRoutes()
  const routes = areaRoutes({area, eventRoutes})

  return (
    <RelativeLink to={routes.root} disableStyles aria-label={label}>
      <Box>
        <span>{area.name}</span>
        <RightSection>
          <span>{totalAttendees}</span>
          <DragHandleWrapper
            active={Boolean(props.dragHandleProps)}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}
          >
            <DragHandle
              visible
              handleProps={props.dragHandleProps ?? undefined}
            />
          </DragHandleWrapper>
        </RightSection>
      </Box>
    </RelativeLink>
  )
}

const Box = styled.div`
  position: relative;
  border: 1px solid ${(props) => props.theme.colors.border};
  padding: ${(props) => props.theme.spacing[5]};
  margin-bottom: ${(props) => props.theme.spacing[4]};
  border-radius: 6px;
  display: flex;
  justify-content: space-between;

  &:hover {
    background: ${grey[200]};
  }
`

const RightSection = styled.span`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing[3]};
`

const DragHandleWrapper = styled.span<{active?: boolean}>`
  display: flex;
  align-items: center;
  visibility: ${(props) => (props.active ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.active ? 'auto' : 'none')};
`
